export const MIN_LAUNCHER_WIDTH = 200;
export const launcherWidth = 60;
export const launcherHeight = 60;
export const pillLauncherWidth = 40;
export const pillLauncherHeight = 40;
export const pillLauncherOpenIconWidth = 26;
export const pillLauncherOpenIconHeight = 24;